import { render } from "./UserProfileEdit.vue?vue&type=template&id=3c91693e&lang=html"
import script from "./UserProfileEdit.vue?vue&type=script&lang=js"
export * from "./UserProfileEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__